import { Tooltip } from 'recharts';
import type { TooltipProps } from 'recharts';
import type {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import {
  chartBarTooltipCursor,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '@/components/ui/charts/chart-theme';

type MetricsChartTooltipProps = TooltipProps<ValueType, NameType> & {
  variant?: 'area' | 'bar';
};

export function MetricsChartTooltip({
  variant = 'area',
  ...props
}: MetricsChartTooltipProps) {
  return (
    <Tooltip
      contentStyle={chartTooltipContentStyle}
      itemStyle={chartTooltipItemStyle}
      labelStyle={chartTooltipLabelStyle}
      cursor={variant === 'bar' ? chartBarTooltipCursor : undefined}
      {...props}
    />
  );
}
